import React from "react";
import { gotoSearchResultsPage } from "../../../search/api/filterUrlMaker";
import { Truncate } from "../../../../lib/Truncate";
import { Pill } from "../../../search/searchBar/Pill";
import { HighlightText } from "../tileView/PublicationCardParts";
import { _t } from "app/i18n/i18n";
import { getReferer } from "lib/routing";
import { truncate } from "lib/utils";

export const PublicationDate = ({ publicationDateLocale = "" }) => <small className="">{publicationDateLocale} </small>;

export const Title = ({ title = "", pubUrl = "", Highlight = "", id = 0 }) => (
  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    href={pubUrl}
    target={id}
    rel="noopener"
    // eslint-disable-next-line react/no-unknown-property
    referer={getReferer()}
    referrerPolicy="no-referrer-when-downgrade"
    className="d-block mt-1 text-primary text-break"
  >
    {Highlight?.title ? (
      <HighlightText text={Highlight.title.toString()} className={Highlight.colour + " d-inline"} />
    ) : (
      title
    )}
  </a>
);

export const Synopsis = ({ synopsis = "", Highlight = "" }) => (
  <div className="text-justify text-muted pr-3 line-clamp-2">
    {Highlight?.content ? (
      <HighlightText text={Highlight.content.toString()} className={Highlight.colour} />
    ) : (
      truncate(synopsis, 400)
    )}
  </div>
);

export const Analysts = ({ analysts = [], lang }) => (
  <Truncate show={4} more={20}>
    {analysts
      .filter((analyst) => analyst.isActive && analyst.isPrimary)
      .map((analyst, key) => (
        <small
          key={key}
          className="text-uppercase cursor-pointer"
          onClick={() => gotoSearchResultsPage("Analyst" + (lang === "ja" ? "-JA" : ""), analyst.name[lang])}
        >
          {key === 0 && " - "}
          {key > 0 && ", "}
          {analyst.name[lang]}
        </small>
      ))}
  </Truncate>
);

export const Tags = (props) => (
  <span className="mt-1 ml-1 d-none d-md-inline">
    <PillList pills={populatePills(props).map(setPadding)} />
  </span>
);

const setPadding = (pill) => ({ ...pill, padding: "p-1" });

export const populatePills = ({
  internal,
  assetClasses = [],
  regions = [],
  periodicals = [],
  reportTypes = [],
  gicsSectors = [],
  gicsIndustryGroups = [],
  lang,
}) => {
  const suffix = lang === "ja" ? "-JA" : "";
  const suffix2 = lang === "ja" ? ".ja" : ".en";
  const pills = [
    ...(internal
      ? [
          {
            text: "INTERNAL ONLY",
            category: "internal",
            value: "true",
            variant: "danger text-primary",
            title: _t("Internal only msg"),
            isShowTitle: 1,
            icon: "far fa-question-circle ml-1 fa-lg d-none d-md-inline",
          },
        ]
      : []),
    ...assetClasses.map((text) => ({ category: "Asset Class" + suffix, text: text[lang], isShowTitle: true })),
    ...regions.map((text) => ({ category: "Regions" + suffix, text: text[lang], isShowTitle: true })),
    ...periodicals.map((text) => ({ category: "periodicals" + suffix2, text: text[lang], isShowTitle: true })),
    ...reportTypes.map((text) => ({ category: "reportTypes" + suffix2, text: text[lang], isShowTitle: true })),
    ...gicsSectors.map((text) => ({ category: "gicsSectors" + suffix2, text: text[lang], isShowTitle: true })),
    ...gicsIndustryGroups.map((text) => ({
      category: "gicsIndustryGroups" + suffix2,
      text: text[lang],
      isShowTitle: true,
    })),
  ];
  return pills;
};

export const PillList = ({ pills }) => (
  <Truncate show={4} more={20}>
    {pills.map(({ text, category, isShowTitle, title, value = text, variant, padding, icon }, key) => (
      <Pill
        key={key}
        text={text}
        margin={"mr-1 mb-1"}
        padding={padding}
        variant={variant}
        title={isShowTitle && (title || category + ": " + text)}
        icon={icon}
        onClick={() => gotoSearchResultsPage(category, value)}
      />
    ))}
  </Truncate>
);
